import { AnyAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { OpenSearchForTransaction } from "./fees.request";
import { FeesInitialStateDTO } from "./types";
import { setToastNotification } from "../../../../components/ToastNotification/service/toastNotificationSlice";

export const initialState: FeesInitialStateDTO = {
  error: false,
  loading: false,
  success: false,
  transactionData: null,
};

export const transactionList = createAsyncThunk(
  "app/transactionList",
  (data: any) => {
    return OpenSearchForTransaction(data)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch((error: any) => {
        throw error.response.data;
      });
  }
);

export const feesSlice = createSlice({
  name: "feesSlice",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(transactionList.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.success = false;
    });
    builder.addCase(transactionList.fulfilled, (state, action: any) => {
      state.loading = false;
      state.error = false;
      state.success = true;
      state.transactionData = action.payload;
    });
    builder.addCase(transactionList.rejected, (state, action: AnyAction) => {
      state.loading = false;
      state.success = false;
      state.error = action?.error?.message || "Something went wrong";
    });
  },
});
export default feesSlice.reducer;
export const { reset } = feesSlice.actions;
